export default {
  type: "string",
  description:
    "CSRF token - Tento parametr není povinný, ale doporučený. Klient by si ho měl uložit do session a porovnat ho s tokenem, který obdrží v odpovědi."
};
